import localeAntd from 'ant-design-vue/lib/locale-provider/ko_KR';

const messages = {
  topBar: {
    profileMenu: {
      hello: '안녕하세요',
      editProfile: '프로필 수정',
      settings: '설정',
      logout: '로그 아웃',
    },
  },
  menuLeft: {
    top: {
      churchDashboard: '교회 대시보드',
    },
    user: {
      churchPartner: '교회 파트너',
      evangelismPartner: '전도 파트너',
    },
    menu: {
      account: '계정',
      dashboard: '계기반',
      profile: '프로필',
      viewProfile: '프로필보기',
      editProfile: '프로필 수정',
      profileVideo: '동영상',
      orderCards: '초대장 주문',
      evangelismBootcamp: '전도 신병 훈련소',
      shareStory: '나의 예수 이야기를 나누다',
      messages: '메시지',
      trackProgress: '진행 상황 추적',
      studyGuides: '학습 가이드',
      bulletinInsert: '게시판 삽입물',
      resources: '자원',
      monthlyVideos: '월간 동영상',
      videoPlayer: '비디오 플레이어',
      campuses: '교회 찾기 주소',
      AccountInvoicePayment: '계정 송장',
      updateBillingInfo: '결제 정보',
      paymentInfo: '결제 정보',
      supportCenter: '지원 센터',
      churchProfile: '교회 프로필',
      churchAccess: '교회 접근',
      testimonials: '사용후기',
      welcomeVideo: '초대 영상',
    },
  },
  pricing: {
    getPricing: '가격 책정',
    title: '가격을 확인하고 가입하려면 교회의 평균 출석을 선택하세요.',
    buttonSelectAbove: '위에서 선택',
    monthlyPlan: '월간 요금제',
    monthlyPlanSub: '(12회 결제 필요)',
    buttonJoinMonthly: '월간 요금제 가입',
    yearlyPlan: '연간 요금제',
    yearlyPlanSub: '(16% 절약)',
    buttonJoinYearly: '연간 요금제 가입',
    multipleDesign3: '삼',
    multipleDesign2: '둘',
    multipleDesign1: '하나',
    errorCard: {
      title: '다음 필드는 유효하지 않은 것으로 보입니다.',
      number: '카드 번호',
      month: '월',
      year: '년도',
      first_name: '이름',
      last_name: '성',
    },
    feature: {
      para0: {
        title: '—- 맞춤형 QR 코드 목사 비디오 초대 카드',
        content: '맞춤형 QR 코드 목사 비디오 초대 카드',
      },
      para1: {
        title: 'TrueLife.org를 사용할 수 있는 1년 라이선스',
        content: 'TrueLife.org를 사용할 수 있는 1년 라이선스',
      },
      para2: {
        title: '대부분의 교회 초청',
        content: '대부분의 교회 초청',
      },
      para3: {
        title: 'True Life Church Locator 시스템에 대한 액세스',
        content: 'True Life Church Locator 시스템에 대한 액세스',
      },
      para4: {
        title: '예수 이야기를 교회 프로필에 연결',
        content: '예수 이야기를 교회 프로필에 연결',
      },
      para5: {
        title: '학습 가이드 및 리더 가이드',
        content: '학습 가이드 및 리더 가이드',
      },
      para6: {
        title: '전도 부트 캠프 및 리더 가이드',
        content: '전도 부트 캠프 및 리더 가이드',
      },
      para7: {
        title: '귀하의 웹사이트를 위한 비디오 플레이어',
        content: '귀하의 웹사이트를 위한 비디오 플레이어',
      },
    },
    guarantees: {
      para1: '위와 그 이상 보장',
      para2: 'TrueLife.org 비디오나 교회가 동의하지 않는 기사가 있으면 전액 환불됩니다.',
      para3: '소개 비디오를 본 후 초대 카드를 디자인하고 인쇄하기 전에 지도부가 거절하면 전액 환불됩니다.',
      para4: '카드를 가지고 30일 동안 우리의 전략을 따를 수 있습니다. ',
    },
  },
  page: {
    dashboardIndividual: {
      introduction: '우리는 당신이 당신의 예수 이야기를 나눌 수 있도록 도와주게 되어 기쁩니다!<br/>소개 영상을 보고 시작하세요!',
    },
    dashboard: {
      getMostFromTruelife: {
        para1: '그들이 카드에 대해 기도하도록 하기 위한 서비스 종료에 대한 예시 문구',
        para2: '형제 자매 여러분, 오늘 여러분은 메시지와 복음을 들었습니다. ',
        para3: '*절대 설교를 열심히 하지 말고 이런 말 없이 메시지를 닫지 마십시오. ',
      },
      churchTraningVideo: {
        para1: '소개 비디오를 다운로드하려면 클릭하십시오.',
      },
      videoShareWithChuch: {
        para1: '소개 비디오를 다운로드하려면 클릭하십시오.',
      },
      getWeeklyResults: {
        para1: '이 2분 비디오에서 매주 결과를 얻는 방법을 알아보세요.',
      },
      accountPaymentDate: {
        para1: '연간 계정 갱신 날짜',
      },
      recentUpdate: {
        para1: '최근 서비스 약관 및 개인 정보 보호 정책을 업데이트했습니다. ',
        link: '여기',
      },
      whyYouShouldUpgrade: {
        para1: '업그레이드하려면 클릭',
      },
    },
    orderCards: {
      instructionsResources: {
        para1: 'TrueLife.org에서 초대장을 주문하려면 이 페이지의 양식을 작성하십시오. ',
      },
      reOrderingInstructions: {
        para1: '카드를 재주문해야 하는 경우 재주문 양식을 사용하십시오.',
        link: '여기를 클릭하세요',
      },
    },
    trackProgress: {
      submitTrackYourProgress: {
        para1: '고객 서비스 팀에서 진행 상황을 추적하려면 이 페이지의 양식을 작성하세요.',
      },
    },
    bulletinInserts: {
      bulletinInserts: {
        para1: '게시판용으로 미리 디자인된 삽입물을 다운로드하십시오.',
        link: '게시판 삽입 키트',
        para2: '키트에 포함',
      },
    },
    videoPlayer: {
      videoPlayerForYourChurchWebsite: {
        para1: '1단계: 교회 웹사이트 URL 입력(예: www.mychurch.com)',
        para2: '2단계: 플레이어에 포함할 범주 선택(또는 모든 범주를 포함하려면 포함 코드 생성을 클릭)',
        para3: '기부 버튼 추가: 기부 페이지 URL 입력',
      },
    },
    campuses: {
      para1: '교회 캠퍼스 위치를 추가하십시오.',
      para2: '위치가 하나뿐인 경우 이름을 그대로 두십시오. ',
      para3: '예: 교회 이름 - 캠퍼스 이름',
      yourLocations: {
        para1: '교회 캠퍼스를 추가하십시오',
      },
    },
    dashboardCare: {
      howToSetupYourChurchProfile: {
        para1: '왼쪽에는 교회 프로필과 교회 접근 메뉴 항목이 모두 표시됩니다. ',
      },
      howToDirectChurchMembersToTruelifeCare: {
        para1: '교회 구성원을 TrueLifeCare.org로 안내하려면 교회 대시보드에 제공된 게시판 삽입물 또는 프로젝터 이미지를 사용하십시오. ',
      },
      whyYouShouldIncludeAPersonalVideoFromThePastor: {
        para1: '목회자의 개인 비디오는 교인들이 교회에서 받아들여지고, 사랑받고, 이해받는다고 느끼는 데 도움이 됩니다. ',
      },
      howToUseTruelifeCareInCounselingSessions: {
        para1: 'TrueLifeCare.org는 상담 세션에서 이러한 리소스를 사용할 수 있도록 만들어졌습니다. ',
      },
      evangelismProgram: {
        para1: 'TrueLife.org 전도에 대해 자세히 알아보려면 클릭하십시오.',
      },
    },
    churchAccess: {
      churchMembersAccessCredentials: {
        para1: '교인과 공유할 로그인 정보를 설정하십시오. ',
      },
    },
    account: {
      churchMembershipInformation: {
        para1: '다음 계정 갱신 날짜',
      },
    },
    support: {
      submitASupportRequest: {
        para1: '고객 서비스 팀의 지원을 요청하려면 이 페이지의 양식을 작성하세요.',
      },
    },
    updateBilling: {
      para1: '계정에 미결 송장이 있습니다. 카드 세부 정보를 업데이트하십시오.',
    },
    welcomeVideo: {
      step1: '환영 비디오 녹화',
      step2: '맞춤 URL 선택',
      step3: '확인!',
      step4: '이제 교회를 연결할 때입니다!',
    },
    shareYourStory: {
      step1: '당신의 이야기를 기록',
      step2: '맞춤 URL 선택',
      step3: '확인!',
      step4: '이제 교회를 연결할 때입니다!',
    },
  },
  cardTitle: {
    yourTestimonials: '당신의 평가',
    shareYourStory: '당신의 이야기를 공유하세요',
    welcomeVideo: '목사 환영 비디오',
    accountPaymentDate: '계정 결제일',
    memberDashboardIntro: '회원 대시보드 소개',
    churchTraningVideo: '초대장 교육 비디오',
    videoShareWithChuch: '예수 이야기 훈련 비디오',
    jesusStoryChurchPayingVideo: '보너스: 초대장 교육 비디오',
    whyYouShouldUpgrade: '업그레이드해야 하는 이유!',
    getMostFromTruelife: '교회의 예수 이야기를 쉽게 사용하고 설정할 수 있습니다.',
    getWeeklyResults: '주간 결과 얻기',
    recentUpdate: '최근 업데이트',
    howToEditChurchProfile: '교회 프로필을 편집하는 방법',
    editYourChurchProfile: '교회 프로필 편집',
    editChurchProfile: '교회 프로필 편집',
    howToOrderCards: '카드 주문 방법',
    cardOrderForm: '카드 주문 양식',
    instructionsResources: '지침',
    reOrderingInstructions: '재주문 지침',
    messageFromTruelifeVisitor: '귀하의 교회를 방문하는 TrueLife.org 방문자의 메시지',
    trackYourProgress: '진행 상황 추적',
    submitTrackYourProgress: '진행 상황 추적 제출',
    studyGuides: '학습 가이드',
    bulletinInserts: '게시판 삽입물',
    howToUseThisWizard: '이 마법사를 사용하는 방법',
    videoPlayerForYourChurchWebsite: '교회 웹사이트용 비디오 플레이어',
    categorySpecificPlayers: '카테고리 특정 선수',
    embedThisCodeInYourwebsite: '웹사이트에 이 코드 삽입',
    previewVideoPlayer: '동영상 플레이어 미리보기',
    howToAddChurchLocation: '교회 위치를 추가하는 방법',
    yourLocations: '내 위치',
    locations: '위치',
    addYourChurchLocation: '교회 위치 추가',
    howToSetupYourChurchProfile: '대시보드 소개 동영상',
    setupShareYourStory: '당신의 교회를 예수 이야기 도전에 초대하십시오!',
    uploadProfileVideo: '프로필 동영상 업로드',
    howToDirectChurchMembersToTruelifeCare: '교인들을 TruelifeCare로 안내하는 방법',
    whyYouShouldIncludeAPersonalVideoFromThePastor: '목회자의 개인 영상을 포함해야 하는 이유',
    howToUseTruelifeCareInCounselingSessions: '상담시 트루라이프케어 사용법',
    evangelismProgram: '전도 프로그램',
    updateChurchProfile: '교회 프로필 업데이트',
    churchMembersAccessCredentials: '교회 회원 액세스 자격 증명',
    churchMembershipInformation: '교회 회원 정보',
    invoices: '인보이스',
    transactions: '업무',
    updateBillingInfo: '결제 정보',
    supportRequest: '지원 요청',
    submitASupportRequest: '지원 요청 제출',
    specificCategoryEmbed: '특정 카테고리 퍼가기',
    churchLocation: {
      adminUpdate: '교회 위치 업데이트',
      adminAdd: '교회 위치 추가',
      update: '교회 위치 업데이트',
      add: '교회 위치 추가',
    },
    socialMedia: '소셜 미디어',
    mediaResources: '미디어 리소스',
    updateYourProfile: '프로필 업데이트',
    settings: '설정',
    connectToChurch: '마지막 도전 단계: 교회를 연결하십시오!',
  },
  button: {
    clear: '분명한',
    download: '다운로드',
    video: '동영상',
    downloadTrainngVideo: '비디오 다운로드',
    updateAccount: '계정 업데이트',
    copyToClipboard: '클립 보드에 복사',
    back: '뒤쪽에',
    nextSelectCategories: '다음: 카테고리 선택',
    nextGenerateEmbedCode: '다음: 임베드 코드 생성',
    createLocation: '위치 생성',
    learnMore: '더 알아보기',
    updateSettings: '업데이트 설정',
    updateProfile: '프로필 업데이트',
    updateUser: '사용자 업데이트',
    createUser: '사용자 만들기',
    updateAnswer: '답변 업데이트',
    createAnswer: '답변 만들기',
    updateCategory: '카테고리 업데이트',
    createCategory: '카테고리 만들기',
    updateSpeakerBio: '발표자 약력 업데이트',
    createSpeakerBio: '발표자 약력 만들기',
    updateLocation: '위치 업데이트',
    createSpecificCategoryEmbed: '특정 카테고리 임베드 만들기',
    save: '구하다',
    submit: '제출하다',
    giveNow: '지금 주세요',
    upload: '업로드',
    cancel: '취소',
    continue: '계속하다',
    socialMediaKit: '소셜 미디어 키트',
    mediaPackage: '미디어 패키지',
    resetMyPassword: '내 비밀번호 재설정',
    goBack: ' 돌아가기',
    login: '로그인',
    signUp: '가입하기',
    yes: '예',
    no: '아니요',
    edit: '편집하다',
    delete: '삭제',
    search: '찾다',
    reset: '초기화',
    hidePreview: '미리보기 숨기기',
    preview: '시사',
    accountDetails: '계정 세부정보',
    downloadCheatSheet: '치트 시트 다운로드',
    readyToGo: '시작하다!',
    startOver: '다시 시작하다',
    uploadVideo: '비디오 업로드',
    recordVideo: '비디오 녹화',
    embedVideo: '동영상 삽입',
    redo: '다시 하다',
    keep: '유지하다',
    redoAll: '모두 다시 실행',
    keepAll: '모두 저장',
    redoTypeVideo: '{type} 비디오 재실행',
    takeThumbnail: '비디오에서 비디오 섬네일을 선택하십시오',
  },
  label: {
    churchDescription: '교회 설명',
    videoEmbed: '동영상 퍼가기',
    serviceTimes: '서비스 시간',
    contactDetails: '연락처 정보',
    website: '웹사이트',
    useWebsite: '프로필 웹사이트 사용',
    phone: '전화 번호',
    facebook: '페이스북',
    twitter: '트위터',
    profileBannerPicture: '프로필 배너 사진',
    pastorsHeadshot: '목회자 얼굴 사진',
    viewMessage: '메시지 보기',
    subject: '주제',
    from: '에서',
    yourDonationPageAddress: '기부 페이지 주소',
    createSpecificCategoryEmbed: '특정 카테고리 임베드 만들기',
    embedThisCodeInYourWebsite: '웹사이트에 이 코드 삽입',
    name: '이름',
    address: '주소',
    address2: '주소 2',
    city: '도시',
    state: '상태',
    zipCode: '우편 번호',
    country: '국가',
    counselingPastor: '상담 목사',
    counselingContactEmail: '상담 연락처 이메일',
    churchAddress: '교회 주소',
    churchPhone: '교회전화',
    churchWebsite: '교회 웹사이트',
    welcomeVideoEmbedCode: '환영 비디오 - 소스 코드',
    email: '이메일',
    password: '비밀번호',
    newPassword: '새 비밀번호',
    churchLoginDetail: '교회 로그인 정보',
    careLogin: '케어 로그인',
    carePassword: '케어 비밀번호',
    invoiceID: '인보이스 ID',
    total: '총',
    download: '다운로드',
    downloadPDF: 'PDF 다운로드',
    status: '상태',
    action: '행동',
    amount: '양',
    date: '날짜',
    invoice: '송장',
    description: '설명',
    firstNameFirstHalfChurchName: '이름(또는 교회 이름 전반부)',
    lastNameSecondHalfChurchName: '성(또는 후반 교회 이름)',
    cardNumber: '카드 번호',
    expirationDate: '만료 날짜',
    CVV: 'CVV',
    pastorFirstName: '목사 이름',
    pastorLastName: '목사 성',
    role: '역할',
    cellPhone: '휴대전화',
    churchName: '교회 이름',
    planInformation: '계획 정보',
    plan: '계획',
    price: '가격',
    errorAccountPlanInvalid: '계정 및 플랜이 유효하지 않음',
    errorAccountInvalid: '유효하지 않은 계정',
    errorPlanInvalid: '잘못된 계획',
    selectFomGallery: '갤러리에서 표지 이미지 선택',
    uploading: '업로드 중',
    nextBillingDate: '다음 청구일',
    contactSupport: '연락처 지원',
    termsOfUse: '이용약관',
    support: '지원하다',
    contacts: '콘택트 렌즈',
    areYouSure: '확실합니까?',
    firstName: '이름',
    lastName: '성',
    search: '찾다',
    embedVideoUrl: '비디오 URL 삽입:',
    pickCustomUrl: '맞춤 URL 선택:',
    truelifeTypePage: 'Truelife {유형} 페이지:',
    directConnectionLink: '목사 초청 링크:',
    inviteModerator: '중재자 초대',
    moderatorInvitationLink: '진행자 초대 링크:',
    somethingWentWrong: '문제가 발생했습니다.',
    slugExists: '이 맞춤 URL은 이미 존재합니다. 다른 URL을 선택하세요.',
    jesusStories: '예수 이야기 비디오:',
    qrCode: 'QR 코드',
    introVideoStatus: {
      created: '검토 중',
      review: '검토 중',
      approved: '승인됨',
      blocked: '막힌',
      no_payment: '무료',
    },
    supportEmail: '지원 이메일',
    designerEmail: '디자이너 이메일',
    welcomeInstructionLink: '환영 명령 링크(P)',
    shareStoryInstructionLink: '예수 이야기 교육 링크(i)',
    mainDashboardVideoLink_p: '메인 대시보드 동영상(P)',
    mainDashboardVideoLink_i: '마니 대시보드 동영상(i)',
    evangelismBootCampLink_p: '전도부트캠프 영상(P)',
    evangelismBootCampLink_i: '전도부트캠프 영상(i)',
    moderatorVideoLink: '중재자 비디오',
    individualSignupLink: '개인 가입',
    reminderStoryLink: '스토리 알림 팝업',
    reminderWelcomeLink: '환영 알림 팝업',
    churchInvitationLink: '목사 초청 영상',
    churchModeratorInvitationLink: '진행자 초대 비디오',
  },
  placeholder: {
    pleaseInputTheLocationName: '지역명을 입력해주세요!',
    pleaseInputYourAddress: '주소를 입력해주세요!',
    pleaseInputYourCity: '도시를 입력하세요!',
    pleaseInputYourState: '상태를 입력해주세요!',
    pleaseInputYourZipcode: '우편번호를 입력해주세요!',
    pleaseInputYourCountry: '국가를 입력하세요!',
    yourChurchWebsiteAddress: '교회 웹사이트 주소',
    yourDonationPageAddress: '기부 페이지 주소',
    pleaseInputPastorFirstName: '목사님 이름을 입력해주세요!',
    pleaseInputPastorLastName: '목사님 성함을 입력해주세요!',
    pleaseInputRole: '역할을 입력해주세요!',
    pleaseInputCellPhone: '휴대폰을 입력해주세요!',
    pleaseInputChurchName: '교회명을 입력해주세요!',
    pleaseInputEmail: '이메일을 입력해주세요!',
    pleaseInputPassword: '비밀번호를 입력해주세요!',
    pleaseInputCarePastor: '케어 목사님을 입력해주세요!',
    pleaseInputCareEmail: '케어 이메일을 입력해주세요!',
    pleaseInputCareAddress: '케어 주소를 입력해주세요!',
    pleaseInputCarePhone: '케어폰을 입력해주세요!',
    pleaseInputCareWebsite: '케어 홈페이지를 입력해주세요!',
    pleaseInputFirstName: '이름을 입력하세요!',
    pleaseInputLastName: '성을 입력하세요!',
    pleaseInputCardNumber: '카드번호를 입력해주세요!',
    pleaseInputMonth: '월을 입력하세요!',
    pleaseInputYear: '연도를 입력하세요!',
    pleaseInputCVV: 'CVV를 입력하세요!',
    pleaseInputAddress: '주소를 입력해주세요!',
    pleaseInputState: '상태를 입력해주세요!',
    pleaseInputCity: '도시를 입력하세요!',
    pleaseInputCountry: '국가를 입력하세요!',
    pleaseInputChurchDescription: '교회 설명을 입력하세요!',
    pleaseInputContactDetails: '연락처를 입력해주세요!',
    pleaseInputTitle: '제목을 입력해주세요!',
    pleaseInputSlug: '슬러그를 입력해주세요!',
    pleaseInputDescription: '설명을 입력해주세요!',
    pleaseSelectAnswerType: '답변 유형을 선택하세요!',
  },
};

export default {
  locale: 'es',
  localeAntd,
  messages,
};
